module.exports = __webpack_public_path__ + "img/img_analyist_dog_lg.fd738248.png";